/*
 * Copyright (c) 2023. Collabro Limited
 */
import React from "react";
import LocalizationProviderSetup from "../../Helper/LocationProviderSetup";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { DateTime } from "luxon";
import { TextField, TextFieldProps } from "@mui/material";
import { East } from "@mui/icons-material";

interface BookingDateProps {
  startDateLabel?: string;
  onStartDateChange: any;
  startDateName?: string;
  startDate: DateTime;
  startMinDate?: DateTime;
  startMaxDate?: DateTime;
  returnDateLabel?: string;
  onReturnDateChange: any;
  returnDateName?: string;
  returnDate: DateTime;
  returnMinDate?: DateTime;
  returnMaxDate?: DateTime;
  returnDateDisabled?: boolean;
}

//TODO: I can probably separate further the date picker component
const BookingDate = (props: BookingDateProps) => {
  return (
    <LocalizationProviderSetup>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
          paddingTop: 10,
        }}
      >
        <div
          style={{
            width: "45%",
          }}
        >
          <DesktopDatePicker
            label={props.startDateLabel ?? "Flight Date"}
            inputFormat="dd/LL/yyyy"
            onChange={props.onStartDateChange}
            value={props.startDate}
            disableMaskedInput
            minDate={props.startMinDate ?? DateTime.now()}
            maxDate={props.startMaxDate ?? DateTime.now().plus({ month: 12 })}
            renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
              <TextField
                name={props.startDateName ?? "startDate"}
                {...params}
                size="small"
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
              />
            )}
          />
        </div>
        <East fontSize="small" />
        <div
          style={{
            width: "45%",
          }}
        >
          <DesktopDatePicker
            label="Return Date"
            inputFormat="dd/LL/yyyy"
            onChange={props.onReturnDateChange}
            value={props.returnDate}
            disabled={props.returnDateDisabled ?? false}
            disableMaskedInput
            minDate={props.returnMinDate ?? DateTime.now()}
            maxDate={props.returnMaxDate ?? DateTime.now().plus({ month: 12 })}
            renderInput={(params: JSX.IntrinsicAttributes & TextFieldProps) => (
              <TextField
                name={props.returnDateName ?? "endDate"}
                {...params}
                size="small"
                onKeyDown={(e) => {
                  e.preventDefault();
                }}
              />
            )}
          />
        </div>
      </div>
    </LocalizationProviderSetup>
  );
};

export default BookingDate;
